export const PTAX_INITIAL_STATE = {
    year: "",
    to_year: "",
    session:"",
    state_id: "",
    tax_cal: [
        {
            min_salary: "",
            max_salary: "",
            tax_amount: ""
        }
    ]
}
export const EMPTY_TAX_SLAB={
    min_salary:"",
    max_salary:"",
    tax_amount:""
}
